<template>
  <div class="menu">
    <ul class="menu-list">
      <li
        v-for="(item, index) in menuList"
        class="f-s-14"
        :class="activeMenu === item.pathName ? 'active' : ''"
        @click="changeIndex(item.pathName)"
        :key="index">
        <div class="menu-icon">
          <i class="iconfont" :class="item.icon"></i>
        </div>
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data () {
    return {
      menuList: [
        {
          name: this.$t('systemSettings'),
          pathName: 'systemSettings',
          icon: 'icon-icon_shezhi'
        },
        // {
        //   name: this.$t('zoneGroupTable'),
        //   pathName: 'zoneGroupTable',
        //   icon: 'icon-chazhaobiaodanliebiao',
        // },
        {
          name: this.$t('deviceTable'),
          pathName: 'deviceTable',
          icon: 'icon-DeviceTable'
        },
        {
          name: this.$t('zoneDelays'),
          icon: 'icon-yanchi',
          pathName: 'delays'
        },
        {
          name: this.$t('silenceableGroup'),
          icon: 'el-icon-connection',
          pathName: 'silenceableGroup'
        },
        {
          name: this.$t('configureNetwork'),
          icon: 'el-icon-monitor',
          pathName: 'configureNetwork'
        },
        {
          name: this.$t('setIoCard'),
          icon: 'el-icon-cpu',
          pathName: 'setIoCard'
        },
        {
          name: this.$t('daynightSchedule'),
          icon: 'icon-riqi',
          pathName: 'schedule'
        },
        {
          name: this.$t('advancedProgramming'),
          icon: 'icon-computer_icon',
          pathName: 'programming'
        },
        {
          name: this.$t('readonlyInformation'),
          icon: 'icon-xinxi',
          pathName: 'infomation'
        }
        // {
        //   name: this.$t('zoneSettings'),
        //   pathName: 'zoneSettings',
        //   icon: 'icon-fsux_tubiao_gongshi_jisuan'
        // }
      ],
      activeMenu: ''
    }
  },
  watch: {
    routeName (val) {
      this.menuList.map(n => {
        if (n.pathName === val) {
          this.activeMenu = n.pathName
        }
      })
    }
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  mounted () {
    this.activeMenu = this.$route.name
  },
  methods: {
    changeIndex (pathName) {
      // this.activeMenu = pathName
      this.$router.push({
        name: pathName,
        query: {
          projectId: this.$route.query.projectId,
          panelNo: this.$route.query.panelNo,
          panelId: this.$route.query.panelId,
          projectName: this.$route.query.projectName
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.menu {
  height: calc(100vh - 102px);
  overflow: hidden;
  .menu-list {
    margin-top: 30px;
    width: 100%;
    // min-width: 300px;
    height: 100%;
    // .blod-font;
    li {
      position: relative;
      margin: 20px 0;
      height: 40px;
      color: @color-primary;
      font-family: baseFont;
      font-weight: normal;
      .pointer();
      .f-s-18();
      .flex();
      .align-center();
      .menu-icon {
        width: 70px;
      }
      i {
        font-size: 24px;
        margin-left: 30px;
        // margin-right: 16px;
      }
      &:first-child {
        margin-top: 0;
      }
      &:before {
        content: '';
        position: absolute;
        width: 0;
        height: 100%;
        border-left: none;
        transition: border-left .2s;
      }
      &:hover {
        color: @color-blue;
      }
      &.active {
        color: @color-blue;
        &:before {
          border-left: 4px solid @color-blue;
        }
      }
    }
  }
}
</style>
